var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoAmountIgstGst(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#5D5FEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.25H12.75C13.1478 14.25 13.5294 14.092 13.8107 13.8107C14.092 13.5294 14.25 13.1478 14.25 12.75C14.25 12.3522 14.092 11.9706 13.8107 11.6893C13.5294 11.408 13.1478 11.25 12.75 11.25H10.5C10.05 11.25 9.675 11.4 9.45 11.7L5.25 15.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.7458L9.45 17.6958C9.675 17.3958 10.05 17.2458 10.5 17.2458H13.5C14.325 17.2458 15.075 16.9458 15.6 16.3458L19.05 13.0458C19.3394 12.7723 19.5083 12.395 19.5196 11.997C19.5308 11.5989 19.3835 11.2127 19.11 10.9233C18.8365 10.6339 18.4592 10.465 18.0612 10.4537C17.6631 10.4425 17.2769 10.5898 16.9875 10.8633L13.8375 13.7883",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15L9 19.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0031 11.9281C16.2043 11.9281 17.1781 10.9543 17.1781 9.75313C17.1781 8.55191 16.2043 7.57812 15.0031 7.57812C13.8019 7.57812 12.8281 8.55191 12.8281 9.75313C12.8281 10.9543 13.8019 11.9281 15.0031 11.9281Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C8.74264 9 9.75 7.99264 9.75 6.75C9.75 5.50736 8.74264 4.5 7.5 4.5C6.25736 4.5 5.25 5.50736 5.25 6.75C5.25 7.99264 6.25736 9 7.5 9Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoAmountIgstGst);
export default __webpack_public_path__ + "static/media/poAmountIgstGst.2d20ccf8fcdd9b34af1ea6a3eb13f4b0.svg";
export { ForwardRef as ReactComponent };